import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import { specialitiesActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { readOnly } from '../../utils/permissions'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  handleSave = speciality => {
    const { onClose, addSpeciality, editSpeciality, changeMessage } = this.props
    if (speciality._id) {
      editSpeciality(speciality).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addSpeciality(speciality).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, speciality) => {
    e.preventDefault()
    const { setSpecialityFormTouched } = this.props

    if (this.props.specialityFormErrors.valid) {
      this.handleSave(speciality)
    } else {
      setSpecialityFormTouched()
    }
    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      speciality,
      handleChangeSpeciality,
      loadingSpeciality,
      specialityFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, clearErrors } = this
    const isReadOnly = readOnly('especialidades', token)

    return (
      <div>
        <Dialog
          modalId={speciality._id ? 'especialidades-editar' : 'especialidades-nova'}
          modalParams={{ registro: speciality._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingSpeciality ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(speciality._id ? 'especialidades-editar' : 'especialidades-nova') + '-title'}>
                {isReadOnly ? (
                  'Especialidade'
                ) : (
                  <Fragment>
                    {speciality._id ? 'Editar especialidade' : 'Cadastrar especialidade'}
                  </Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'speciality-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, speciality)
                  }}
                >
                  <FormControl
                    error={
                      !((specialityFormErrors.fields || {})['nome'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Especialidade</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeSpeciality({ ...speciality, nome: e.target.value })
                      }}
                      value={speciality.nome}
                      autoFocus
                      id="field-nome"
                    />
                    {!((specialityFormErrors.fields || {})['nome'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((specialityFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button type={'submit'} form={'speciality-form'} color="primary" variant="raised">
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    speciality: state.specialities.speciality,
    loadingSpeciality: state.specialities.loadingSpeciality,
    specialityFormErrors: state.specialities.specialityFormErrors,
    formTouched: state.specialities.specialityFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(specialitiesActions.openModal())
    },
    closeModal: () => {
      dispatch(specialitiesActions.closeModal())
    },
    handleChangeSpeciality: speciality => {
      dispatch(specialitiesActions.handleChangeSpeciality(speciality))
    },
    addSpeciality: speciality => {
      return dispatch(specialitiesActions.addSpeciality(speciality))
    },
    editSpeciality: speciality => {
      return dispatch(specialitiesActions.editSpeciality(speciality))
    },
    setSpecialityFormTouched: speciality => {
      dispatch(specialitiesActions.setSpecialityFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/Specialities/EditModal.js